/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum UnitType {
  Unit = "Unit",
  Week = "Week",
  Term = "Term",
  Day = "Day",
}

export enum SeasonType {
  High = 0,
  Mid = 1,
}

export enum SalesItemType {
  None = "None",
  Tax = "Tax",
  SystemArticle = "SystemArticle",
  EnrollmentFee = "EnrollmentFee",
  Item = "Item",
  Vtm = "Vtm",
  Other = "Other",
  Insurance = "Insurance",
  Travel = "Travel",
  Accommodation = "Accommodation",
  Deposit = "Deposit",
  Course = "Course",
  CourseSpecific = "CourseSpecific",
  SpecialArticle = "SpecialArticle",
}

export enum SalesItemSubType {
  NoSubtype = "NoSubtype",
  AgentCommission = "AgentCommission",
  Discount = "Discount",
  ExplorePack = "ExplorePack",
  FunPack = "FunPack",
  SportsOptions = "SportsOptions",
  Transfer = "Transfer",
  CaxInsurance = "CaxInsurance",
  EnrollmentFee = "EnrollmentFee",
  HostFamily = "HostFamily",
  HostFamilyExtraNight = "HostFamilyExtraNight",
  Hotel = "Hotel",
  NoAccommodation = "NoAccommodation",
  Other = "Other",
  Residence = "Residence",
  ResidenceExtraNight = "ResidenceExtraNight",
  OptionalExcursions = "OptionalExcursions",
  PostTours = "PostTours",
  HotelExtraNight = "HotelExtraNight",
  ProtectionCoverage = "ProtectionCoverage",
  Activities = "Activities",
  Flight = "Flight",
  ReunionParty = "ReunionParty",
  Meals = "Meals",
  TravelInsurance = "TravelInsurance",
  ActivityVouchers = "ActivityVouchers",
  AcademicClasses = "AcademicClasses",
  Internship = "Internship",
  Books = "Books",
  AccommodationServices = "AccommodationServices",
  Gadgets = "Gadgets",
  Scholarship = "Scholarship",
  VisaRelated = "VisaRelated",
  UniversityCounselling = "UniversityCounselling",
  TuitionDeposit = "TuitionDeposit",
  AccommodationDeposit = "AccommodationDeposit",
  WorkAndTravel = "WorkAndTravel",
  Item = "Item",
  BoatTrainBus = "BoatTrainBus",
  ExamExtension = "ExamExtension",
  VtmCard = "VtmCard",
  ArrivalTransfer = "ArrivalTransfer",
  DepartureTransfer = "DepartureTransfer",
  ArrivalAndDeparture = "ArrivalAndDeparture",
  Extension = "Extension",
  Termination = "Termination",
  LocalTransportation = "LocalTransportation",
  BalanceCleanup = "BalanceCleanup",
  Refunds = "Refunds",
  SPINChoice = "SPINChoice",
  Course = "Course",
}

export enum ResponseCourseStartDateStatus {
  Active = "Active",
  Past = "Past",
  Deleted = "Deleted",
}

export enum RequestCourseStartDateStatus {
  Active = "Active",
  Past = "Past",
  Deleted = "Deleted",
  All = "All",
}

export enum PriceValidationErrorType {
  Information = "Information",
  Warning = "Warning",
  Error = "Error",
  LimitExceeded = "LimitExceeded",
}

export enum PriceType {
  FP = "FP",
  EP = "EP",
  FI = "FI",
  NP = "NP",
}

export enum OfferType {
  Undefined = 0,
  Individual = 1,
  Group = 2,
  All = 3,
}

export enum ImportBatchStatus {
  UploadPending = "UploadPending",
  ValidatingAndPopulatingStagingTable = "ValidatingAndPopulatingStagingTable",
  UploadFailed = "UploadFailed",
  ApplyPending = "ApplyPending",
  ApplyStarted = "ApplyStarted",
  ApplyProcessing = "ApplyProcessing",
  ApplyCompleted = "ApplyCompleted",
  ApplyFailed = "ApplyFailed",
}

export enum EdmTypeKind {
  None = 0,
  Primitive = 1,
  Entity = 2,
  Complex = 3,
  Collection = 4,
  EntityReference = 5,
  Enum = 6,
  TypeDefinition = 7,
  Untyped = 8,
  Path = 9,
}

export enum EdmSchemaElementKind {
  None = 0,
  TypeDefinition = 1,
  Term = 2,
  Action = 3,
  EntityContainer = 4,
  Function = 5,
}

export enum EdmExpressionKind {
  None = 0,
  BinaryConstant = 1,
  BooleanConstant = 2,
  DateTimeOffsetConstant = 3,
  DecimalConstant = 4,
  FloatingConstant = 5,
  GuidConstant = 6,
  IntegerConstant = 7,
  StringConstant = 8,
  DurationConstant = 9,
  Null = 10,
  Record = 11,
  Collection = 12,
  Path = 13,
  If = 14,
  Cast = 15,
  IsOf = 16,
  FunctionApplication = 17,
  LabeledExpressionReference = 18,
  Labeled = 19,
  PropertyPath = 20,
  NavigationPropertyPath = 21,
  DateConstant = 22,
  TimeOfDayConstant = 23,
  EnumMember = 24,
  AnnotationPath = 25,
}

export enum EdmContainerElementKind {
  None = 0,
  EntitySet = 1,
  ActionImport = 2,
  FunctionImport = 3,
  Singleton = 4,
}

export enum CourseStartDateStatus {
  Active = "Active",
  Past = "Past",
  Deleted = "Deleted",
}

export enum BlockType {
  Unknown = "Unknown",
  Intro = "Intro",
  Term = "Term",
  Break = "Break",
  Departure = "Departure",
}

export enum ApplyType {
  None = "None",
  Mandatory = "Mandatory",
  Suggested = "Suggested",
}

export enum AgeGroup {
  Senior = 0,
  Junior = 1,
  FiftyPlus = 2,
}

export interface AccommodationSaleItem {
  additionalDescription?: string | null;
  applyType?: string | null;
  articleSetting?: ArticleSetting | null;
  code?: string | null;
  courseType?: string | null;
  description?: string | null;
  destination?: string | null;
  duration?: string | null;
  /** @format date-time */
  endDate?: string;
  englishDescription?: string | null;
  isDeleted?: boolean;
  isOptional?: boolean;
  isPublic?: boolean;
  isRefundable?: boolean;
  price?: CoursePrice | null;
  showOnEfCom?: boolean;
  sku?: string | null;
  /** @format date-time */
  startDate?: string;
  subType?: string | null;
  type?: string | null;
}

export interface AccommodationSettingsResponseDto {
  /** @format int32 */
  daysToAdd?: number | null;
  /** @format int32 */
  daysToReduce?: number | null;
  destination?: string | null;
  /** @format int32 */
  endWeek?: number | null;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  isActive?: number | null;
  program?: string | null;
  /** @format int32 */
  startWeek?: number | null;
}

export interface AgeLimitsDto {
  /** @format int32 */
  maximumAge?: number | null;
  /** @format int32 */
  minimumAge?: number | null;
}

export interface AgeRange {
  /** @format int32 */
  max?: number | null;
  /** @format int32 */
  min?: number | null;
}

export interface ApplyBatchRequestDto {
  /** @format guid */
  batchId?: string;
}

export interface ArticleSetting {
  /** @format int32 */
  ageFrom?: number;
  /** @format int32 */
  ageTo?: number;
  articleCode?: string | null;
  isEnsuite?: boolean;
  isExtraNight?: boolean;
  quality?: string | null;
  residenceSubtype?: string | null;
  roomType?: string | null;
  supplierType?: string | null;
}

export interface ArticleSettingDto {
  /** @format int32 */
  ageFrom?: number;
  /** @format int32 */
  ageTo?: number;
  isEnsuite?: boolean;
  quality?: string | null;
  roomType?: string | null;
  supplierType?: string | null;
}

export interface BrochureODataDto {
  brochure?: string | null;
  /** @format date-time */
  endDate?: string;
  /** @format int32 */
  id?: number;
  isDefault?: boolean;
  isEnabled?: boolean;
  isGroupOffer?: boolean;
  market?: string | null;
  program?: string | null;
  season?: string | null;
  /** @format date-time */
  startDate?: string;
}

export interface BrochureSeasonResponseV2Dto {
  isDefault?: boolean;
  name?: string | null;
  year?: string | null;
}

export interface ChildDestination {
  code?: string | null;
  languageCode?: string | null;
}

export interface CourseDto {
  accommodation?: string | null;
  additionalDescription?: string | null;
  ageGroup?: string | null;
  category?: string | null;
  code?: string | null;
  /** @format int32 */
  days?: number;
  description?: string | null;
  destination?: string | null;
  destinationName?: string | null;
  duration?: string | null;
  /** @format date-time */
  endDate?: string;
  englishDescription?: string | null;
  /** @format int32 */
  id?: number;
  isDeleted?: boolean;
  isPublic?: boolean;
  isRefundable?: boolean;
  name?: string | null;
  /** @format int32 */
  noOfBookings?: number;
  price?: CoursePrice | null;
  program?: string | null;
  showOnEfCom?: boolean;
  /** @format int32 */
  size?: number | null;
  sku?: string | null;
  /** @format date-time */
  startDate?: string;
  status?: string | null;
  travel?: string | null;
  type?: CourseTypeDto | null;
}

export interface CoursePrice {
  isRounding?: boolean;
  prices?: PriceTier[] | null;
  priceType?: PriceType;
  unit?: UnitType;
}

export interface CourseStartDateSettingDto {
  courseCode?: string | null;
  destinationCode?: string | null;
  /** @format date-time */
  endDate?: string | null;
  isBeginner?: boolean;
  isGroup?: boolean;
  isReguler?: boolean;
  programCode?: string | null;
  /** @format date-time */
  startDate?: string | null;
  status?: ResponseCourseStartDateStatus;
  /** @format date-time */
  timeStamp?: string;
}

export interface CourseTypeAgeGroupEntity {
  ageGroup?: string | null;
  courseTypeCode?: string | null;
  /** @format date-time */
  updatedAt?: string;
}

export type CourseTypeByCategory = CourseTypeV2 & {
  category?: string | null;
};

export interface CourseTypeDto {
  ageGroup?: string | null;
  code?: string | null;
  displayName?: string | null;
  groupOffer?: boolean;
  /** @format int32 */
  hoursPerWeek?: number | null;
  individualOffer?: boolean;
  junoCategory?: string | null;
  name?: string | null;
  type?: string | null;
}

export interface CourseTypeEntity {
  ageGroup?: string | null;
  ageGroups?: CourseTypeAgeGroupEntity[] | null;
  code?: string | null;
  courseTypeCode?: string | null;
  courseTypeGroup?: string | null;
  displayName?: string | null;
  duration?: string | null;
  groupOffer?: boolean;
  /** @format int32 */
  hoursPerWeek?: number | null;
  individualOffer?: boolean;
  junoCategory?: string | null;
  name?: string | null;
  type?: string | null;
}

export type CourseTypeV2 = CourseTypeEntity & {
  program?: string | null;
  ageGroup?: string[] | null;
  ageRange?: AgeRange | null;
};

export interface CreateImportBatchRequestDto {
  contentType?: string | null;
  importType?: string | null;
}

export interface CreateImportBatchResponseDto {
  appliedBy?: string | null;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  /** @format guid */
  id?: string;
  status?: ImportBatchStatus;
  type?: string | null;
  /** @format date-time */
  updatedAt?: string;
  uploadUrl?: string | null;
}

export interface CurrencyResponseDto {
  code?: string | null;
  isDefault?: boolean;
  name?: string | null;
  /** @format decimal */
  rounding?: number;
}

export interface DeparturePoint {
  code?: string | null;
  isGroupDefault?: boolean;
  name?: string | null;
}

export interface DeparturePointResponseDto {
  code?: string | null;
  isEurope?: boolean;
  isGroupDefault?: boolean;
  market?: MarketDto | null;
  name?: string | null;
}

export interface Destination {
  ageGroup?: string | null;
  code?: string | null;
  currencyCode?: string | null;
  defaultAccommodation?: string | null;
  euNonEu?: string | null;
  group?: string | null;
  hemisphere?: string | null;
  /** @format int32 */
  id?: number;
  isEnglish?: boolean;
  language?: string | null;
  mainGateway?: string | null;
  name?: string | null;
  program?: string | null;
}

export type DestinationByCourseCategory = DestinationV2 & {
  courseCategories?: string[] | null;
  courseOfferTypes?: string[] | null;
  courseAgeGroups?: string[] | null;
};

export interface DestinationEntity {
  accommodation?: string | null;
  category?: string | null;
  city?: string | null;
  code?: string | null;
  countryCode?: string | null;
  currencyCode?: string | null;
  defaultAccommodation?: string | null;
  displayName?: string | null;
  euNonEu?: string | null;
  group?: string | null;
  groupOffer?: boolean;
  hemisphere?: string | null;
  individual?: boolean;
  isEnglish?: boolean;
  juniorGroups?: boolean;
  juniorIndividual?: boolean;
  language?: string | null;
  languageCode?: string | null;
  mainGateway?: string | null;
  /** @format int32 */
  maxAge?: number | null;
  /** @format int32 */
  minAge?: number | null;
  name?: string | null;
  permanentSchool?: boolean;
  primaryDestinationCode?: string | null;
  salesForceId?: string | null;
  seniorGroups?: boolean;
  summerSchool?: boolean;
  /** @format guid */
  uuid?: string | null;
}

export interface DestinationOverviewDto {
  ageLimits?: AgeLimitsDto | null;
  currencyCode?: string | null;
  destinationCode?: string | null;
  hemisphere?: string | null;
  isEuropeanUnionCountry?: boolean;
  languageCode?: string | null;
}

export type DestinationV2 = DestinationEntity & {
  program?: string | null;
  parentDestination?: string | null;
  childDestinations?: ChildDestination[] | null;
  seasonSupplements?: SeasonSupplement[] | null;
};

export interface FixedFlightFare {
  currency?: string | null;
  departurePoint?: string | null;
  destinationGateway?: string | null;
  hemisphere?: string | null;
  /** @format decimal */
  price?: number;
  program?: string | null;
  /** @format decimal */
  rebookingFee?: number;
  seasonName?: string | null;
}

export interface FixedFlightFareImportODataDto {
  batchId?: string | null;
  currency?: string | null;
  departurePoint?: string | null;
  destinationGateway?: string | null;
  flightSeason?: string | null;
  /** @format int32 */
  id?: number;
  market?: string | null;
  /** @format decimal */
  price?: number;
  program?: string | null;
  /** @format decimal */
  rebookingFee?: number;
  /** @format date-time */
  validFrom?: string;
  /** @format date-time */
  validTo?: string;
}

export interface FixedFlightFareODataDto {
  currency?: string | null;
  departurePoint?: string | null;
  destinationGateway?: string | null;
  flightSeason?: string | null;
  /** @format int32 */
  id?: number;
  market?: string | null;
  /** @format decimal */
  price?: number;
  program?: string | null;
  /** @format decimal */
  rebookingFee?: number;
  /** @format date-time */
  validFrom?: string;
  /** @format date-time */
  validTo?: string;
}

export interface GenericSupplementResponseDto {
  brochure?: string | null;
  code?: string | null;
  endDate?: string | null;
  group?: boolean;
  hemisphere?: string | null;
  individual?: boolean;
  market?: string | null;
  startDate?: string | null;
}

export interface GroupSpecificBundleSettingResponseDto {
  articleCodes?: string[] | null;
  groupId?: string | null;
}

export type IEdmDirectValueAnnotationsManager = object;

export interface IEdmEntityContainer {
  elements?: IEdmEntityContainerElement[] | null;
}

export interface IEdmEntityContainerElement {
  container?: IEdmEntityContainer | null;
  containerElementKind?: EdmContainerElementKind;
}

export interface IEdmExpression {
  expressionKind?: EdmExpressionKind;
}

export interface IEdmModel {
  declaredNamespaces?: string[] | null;
  directValueAnnotationsManager?: IEdmDirectValueAnnotationsManager | null;
  entityContainer?: IEdmEntityContainer | null;
  referencedModels?: IEdmModel[] | null;
  schemaElements?: IEdmSchemaElement[] | null;
  vocabularyAnnotations?: IEdmVocabularyAnnotation[] | null;
}

export interface IEdmSchemaElement {
  namespace?: string | null;
  schemaElementKind?: EdmSchemaElementKind;
}

export interface IEdmTerm {
  appliesTo?: string | null;
  defaultValue?: string | null;
  type?: IEdmTypeReference | null;
}

export interface IEdmType {
  typeKind?: EdmTypeKind;
}

export interface IEdmTypeReference {
  definition?: IEdmType | null;
  isNullable?: boolean;
}

export type IEdmVocabularyAnnotatable = object;

export interface IEdmVocabularyAnnotation {
  qualifier?: string | null;
  target?: IEdmVocabularyAnnotatable | null;
  term?: IEdmTerm | null;
  usesDefault?: boolean;
  value?: IEdmExpression | null;
}

export interface ImportBatchLightResponseDto {
  appliedBy?: string | null;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  /** @format guid */
  id?: string;
  status?: ImportBatchStatus;
  type?: string | null;
  /** @format date-time */
  updatedAt?: string;
}

export interface ImportBatchResponseDto {
  appliedBy?: string | null;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  errors?: PriceValidationErrorDto[] | null;
  /** @format guid */
  id?: string;
  status?: ImportBatchStatus;
  type?: string | null;
  /** @format date-time */
  updatedAt?: string;
}

export interface MarketDto {
  code?: string | null;
  name?: string | null;
}

export interface ODataAnnotatable {
  typeAnnotation?: ODataTypeAnnotation | null;
}

export type ODataEntitySetInfo = ODataServiceDocumentElement & object;

export type ODataFunctionImportInfo = ODataServiceDocumentElement & object;

export type ODataServiceDocument = ODataAnnotatable & {
  entitySets?: ODataEntitySetInfo[] | null;
  singletons?: ODataSingletonInfo[] | null;
  functionImports?: ODataFunctionImportInfo[] | null;
};

export type ODataServiceDocumentElement = ODataAnnotatable & {
  /** @format uri */
  url?: string | null;
  name?: string | null;
  title?: string | null;
};

export type ODataSingletonInfo = ODataServiceDocumentElement & object;

export interface ODataTypeAnnotation {
  typeName?: string | null;
}

export interface PaginatedResponseOfImportBatchLightResponseDto {
  _links?: PaginationLinks | null;
  items?: ImportBatchLightResponseDto[] | null;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  offset?: number;
}

export interface PaginationLink {
  href?: string | null;
}

export interface PaginationLinks {
  next?: PaginationLink | null;
  previous?: PaginationLink | null;
  self?: PaginationLink | null;
}

export interface PriceDto {
  isRounding?: boolean;
  prices?: PriceSegmentDto[] | null;
  priceType?: PriceType;
  unit?: UnitType;
}

export interface PriceImportODataDto {
  articleCode?: string | null;
  batchId?: string | null;
  brochure?: string | null;
  currency?: string | null;
  destination?: string | null;
  /** @format int32 */
  id?: number;
  isRounding?: boolean;
  market?: string | null;
  /** @format decimal */
  price?: number;
  priceType?: string | null;
  program?: string | null;
  /** @format int32 */
  quantityFrom?: number;
  /** @format int32 */
  quantityTo?: number;
  season?: string | null;
  specialFlags?: string | null;
  unitType?: string | null;
}

export interface PriceODataDto {
  batchUuid?: string | null;
  brochure?: string | null;
  brochureSeasonIdCode?: string | null;
  currency?: string | null;
  destinationCode?: string | null;
  /** @format int32 */
  id?: number;
  isDeleted?: boolean;
  isEnabled?: boolean;
  isRounding?: boolean;
  market?: string | null;
  /** @format decimal */
  price?: number;
  priceType?: string | null;
  program?: string | null;
  /** @format int32 */
  quantityFrom?: number;
  /** @format int32 */
  quantityTo?: number;
  salesItemCode?: string | null;
  salesItemSku?: string | null;
  season?: string | null;
  unitType?: string | null;
}

export interface PriceSegmentDto {
  currency?: string | null;
  isDeleted?: boolean;
  /** @format int32 */
  quantityFrom?: number;
  /** @format int32 */
  quantityTo?: number;
  /** @format decimal */
  value?: number;
}

export interface PriceTier {
  currency?: string | null;
  isDeleted?: boolean;
  /** @format int32 */
  quantityFrom?: number;
  /** @format int32 */
  quantityTo?: number;
  /** @format decimal */
  value?: number;
}

export interface PriceValidationErrorDto {
  message?: string | null;
  severity?: PriceValidationErrorType;
}

export interface ProgramEntity {
  code?: string | null;
  displayProduct?: string | null;
  displayProgram?: string | null;
  isEnabled?: boolean | null;
  market?: string | null;
  name?: string | null;
  product?: string | null;
}

export interface SalesItemDueResultData {
  code?: string | null;
  due?: string | null;
  isEnabled?: boolean;
}

export interface SalesItemInclusionTypeInsertODataDto {
  brochure?: string | null;
  inclusionType?: string | null;
  market?: string | null;
  program?: string | null;
  salesItemCode?: string | null;
  salesItemSku?: string | null;
}

export type SalesItemInclusionTypeODataDto =
  SalesItemInclusionTypeInsertODataDto & {
    /** @format int32 */
    id?: number;
    /** @format int32 */
    salesItemId?: number;
    isDeleted?: boolean;
  };

export interface SalesItemResponseDto {
  additionalDescription?: string | null;
  applyType?: ApplyType;
  articleSetting?: ArticleSettingDto | null;
  code?: string | null;
  courseType?: string | null;
  description?: string | null;
  destination?: string | null;
  duration?: string | null;
  englishDescription?: string | null;
  isActive?: boolean | null;
  isDeleted?: boolean;
  isOptional?: boolean;
  isPublic?: boolean;
  isRefundable?: boolean;
  price?: PriceDto | null;
  showOnEfCom?: boolean;
  sku?: string | null;
  subType?: SalesItemSubType;
  type?: SalesItemType;
}

export type SeasonSupplement = SupplementEntity & {
  seasonType?: SeasonType;
};

export interface SingleResult {
  queryable?: any[] | null;
}

export type SingleResultOfBrochureODataDto = SingleResult & {
  queryable?: BrochureODataDto[] | null;
};

export type SingleResultOfFixedFlightFareImportODataDto = SingleResult & {
  queryable?: FixedFlightFareImportODataDto[] | null;
};

export type SingleResultOfFixedFlightFareODataDto = SingleResult & {
  queryable?: FixedFlightFareODataDto[] | null;
};

export type SingleResultOfPriceImportODataDto = SingleResult & {
  queryable?: PriceImportODataDto[] | null;
};

export type SingleResultOfPriceODataDto = SingleResult & {
  queryable?: PriceODataDto[] | null;
};

export type SingleResultOfSalesItemInclusionTypeODataDto = SingleResult & {
  queryable?: SalesItemInclusionTypeODataDto[] | null;
};

export type SingleResultOfTranslationODataDto = SingleResult & {
  queryable?: TranslationODataDto[] | null;
};

export interface StartDateTermsSettingEntity {
  courseCode?: string | null;
  destinationCode?: string | null;
  /** @format date-time */
  endDate?: string | null;
  isBeginner?: boolean;
  isGroup?: boolean;
  isReguler?: boolean;
  programCode?: string | null;
  /** @format date-time */
  startDate?: string | null;
  status?: CourseStartDateStatus;
  terms?: TermsBlockDto[] | null;
  /** @format date-time */
  timeStamp?: string;
}

export interface SupplementEntity {
  brochure?: string | null;
  code?: string | null;
  /** @format date-time */
  endDate?: string | null;
  hemisphere?: string | null;
  market?: string | null;
  /** @format date-time */
  startDate?: string | null;
}

export interface TermsBlockDto {
  blockType?: BlockType;
  /** @format date-time */
  endDate?: string;
  /** @format int32 */
  order?: number;
  /** @format date-time */
  startDate?: string;
}

export interface TranslationODataDto {
  additionalDescription?: string | null;
  /** @minLength 1 */
  articleCode: string;
  /** @format int32 */
  id?: number;
  /** @minLength 1 */
  languageTag: string;
  /** @minLength 1 */
  market: string;
  /** @minLength 1 */
  program: string;
  /** @format int32 */
  salesItemType?: number;
  translation?: string | null;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "http://localhost:58612";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Product Catalog API v3
 * @version 3
 * @baseUrl http://localhost:58612
 *
 * API documentation for Product Catalog - v3
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  api = {
    /**
 * No description
 *
 * @tags AccommodationSettings
 * @name AccommodationSettingsGetAccommodationSettings
 * @summary Get accommodation settings for provided program and an optional destination.
The result contains also settings for destination `ALL`.
 * @request GET:/api/accommodationsettings
 * @secure
 */
    accommodationSettingsGetAccommodationSettings: (
      query?: {
        /** The destination code */
        Destination?: string | null;
        /** The program code */
        Program?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<AccommodationSettingsResponseDto[], void>({
        path: `/api/accommodationsettings`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returned responses might be served from cache. Cached responses are delivered with the response header Cache-Control containing the max-age value in seconds indicating the cache interval set for the responses of this endpoint.
     *
     * @tags BrochureSeasons
     * @name BrochureSeasonsGetBrochureSeasons
     * @summary Get list of Brochures and Seasons
     * @request GET:/api/v3/brochureseasons
     * @deprecated
     * @secure
     */
    brochureSeasonsGetBrochureSeasons: (
      query: {
        /**
         * @minLength 1
         * @maxLength 3
         */
        Market: string | null;
        /** @minLength 1 */
        Program: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<BrochureSeasonResponseV2Dto[], void>({
        path: `/api/v3/brochureseasons`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returned responses might be served from cache. Cached responses are delivered with the response header Cache-Control containing the max-age value in seconds indicating the cache interval set for the responses of this endpoint.
     *
     * @tags BrochureSeasons
     * @name BrochureSeasonsGetActiveBrochureSeason
     * @summary Get active or latest brochures and seasons
     * @request GET:/api/v3/brochureseasons/active
     * @deprecated
     * @secure
     */
    brochureSeasonsGetActiveBrochureSeason: (
      query: {
        /**
         * @minLength 1
         * @maxLength 3
         */
        Market: string | null;
        /** @minLength 1 */
        Program: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<BrochureSeasonResponseV2Dto, void>({
        path: `/api/v3/brochureseasons/active`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BundleSettings
     * @name BundleSettingsGetAllBundleSettingsForSpecialGroups
     * @summary Get group specific bundle settings
     * @request GET:/api/v3/bundlesettings/groupspecific
     * @deprecated
     * @secure
     */
    bundleSettingsGetAllBundleSettingsForSpecialGroups: (
      params: RequestParams = {},
    ) =>
      this.request<GroupSpecificBundleSettingResponseDto[], void>({
        path: `/api/v3/bundlesettings/groupspecific`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Should brochure and season not be provided, the result will be filtered by active/latest brochure automatically.
     *
     * @tags Courses
     * @name CoursesGetCourseBySkuV3
     * @summary Get specific course based on sku.
     * @request GET:/api/v3/courses/{sku}
     * @deprecated
     * @secure
     */
    coursesGetCourseBySkuV3: (
      sku: string,
      query?: {
        /** The age group code */
        AgeGroup?: string | null;
        /** The brochure code as in year */
        Brochure?: string | null;
        /** The three digits currency code */
        Currency?: string | null;
        /** The departure point code */
        DeparturePoint?: string | null;
        /** The destination code */
        Destination?: string | null;
        /** Include (soft) deleted articles and prices from PII */
        IncludeDeleted?: boolean | null;
        /** Boolean type to filter articles disabled in PII */
        IncludeInactive?: boolean;
        /** Boolean type to filter the articles for public websites */
        IsPublic?: boolean | null;
        /** The language code */
        Language?: string | null;
        /** The three digit market code */
        Market?: string | null;
        /** The program code */
        Program?: string | null;
        /** The season version */
        Season?: string | null;
        /**
         * The article subtype
         * @format int32
         */
        SubType?: number;
        /**
         * The article type
         * @format int32
         */
        Type?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<SalesItemResponseDto, void>({
        path: `/api/v3/courses/${sku}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Courses
     * @name CoursesGetCoursesByCategoryV3
     * @summary Get specific courses By category
     * @request GET:/api/v3/courses
     * @secure
     */
    coursesGetCoursesByCategoryV3: (
      query?: {
        /** Filters Groups based on age group. E.g. Senior, Junior */
        AgeGroup?: AgeGroup | null;
        /** The brochure as in year */
        Brochure?: string | null;
        /** Filters the list by course category */
        Category?: string | null;
        /** Code of the article behind the course */
        Code?: string | null;
        /** The three digits currency code */
        Currency?: string | null;
        /** Filters the departure points */
        DeparturePoint?: string | null;
        /** The destination code */
        Destination?: string | null;
        /** Include (soft) deleted articles and prices from PII */
        IncludeDeleted?: boolean | null;
        /** Boolean type to filter articles disabled in PII */
        IncludeInactive?: boolean;
        /** Boolean code indicates the course is for public websites */
        IsPublic?: boolean | null;
        /** The language code */
        Language?: string | null;
        /** The three digit market code */
        Market?: string | null;
        /** Offer type, eg. Junior, Senior, 50+ */
        OfferType?: OfferType;
        /** The program codes (separated by commas) */
        Program?: string | null;
        /** The season version */
        Season?: string | null;
        /**
         * The course type
         * @format int32
         */
        Type?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<CourseDto[], void>({
        path: `/api/v3/courses`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CourseStartDate
     * @name CourseStartDateGetCourseStartDate
     * @summary Get Course Start Date
     * @request GET:/api/v3/coursestartdate
     * @secure
     */
    courseStartDateGetCourseStartDate: (
      query: {
        /** @minLength 1 */
        CourseCode: string | null;
        /** @minLength 1 */
        Destination: string | null;
        /** @minLength 1 */
        Program: string | null;
        /** @format date-time */
        StartDate?: string | null;
        Status?: RequestCourseStartDateStatus;
      },
      params: RequestParams = {},
    ) =>
      this.request<CourseStartDateSettingDto[], void>({
        path: `/api/v3/coursestartdate`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CourseStartDate
     * @name CourseStartDateGetCourseTerms
     * @summary Get course terms blocks
     * @request GET:/api/v3/coursestartdate/terms
     * @secure
     */
    courseStartDateGetCourseTerms: (
      query: {
        /** @minLength 1 */
        CourseCode: string | null;
        /** @minLength 1 */
        Destination: string | null;
        /** @minLength 1 */
        Program: string | null;
        /** @format date-time */
        StartDate: string | null;
        Status?: RequestCourseStartDateStatus;
      },
      params: RequestParams = {},
    ) =>
      this.request<StartDateTermsSettingEntity, void>({
        path: `/api/v3/coursestartdate/terms`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CourseType
     * @name CourseTypeGetCourseTypes
     * @summary Get specific course Types for category
     * @request GET:/api/v3/coursetype
     * @secure
     */
    courseTypeGetCourseTypes: (
      query: {
        /**
         * The three digit market code
         * @minLength 1
         * @maxLength 3
         */
        Market: string | null;
        /**
         * The program codes (separated by commas)
         * @minLength 1
         */
        Program: string | null;
        /** The brochure as in year */
        Brochure?: string | null;
        /** Filters the list by course category */
        Category?: string | null;
        /** The three digits currency code */
        Currency?: string | null;
        /** The destination code */
        Destination?: string | null;
        /** Boolean code indicates the course is for public websites */
        IsPublic?: boolean | null;
        /** The season version */
        Season?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<CourseTypeByCategory[], void>({
        path: `/api/v3/coursetype`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returned responses might be served from cache. Cached responses are delivered with the response header Cache-Control containing the max-age value in seconds indicating the cache interval set for the responses of this endpoint.
     *
     * @tags Currencies
     * @name CurrenciesGetCurrency
     * @summary Get currencies by required parameter market and optional parameter currency.
     * @request GET:/api/v3/currencies
     * @secure
     */
    currenciesGetCurrency: (
      query: {
        /**
         * The three digits market code
         * @minLength 1
         * @maxLength 3
         */
        Market: string | null;
        /** The three digits currency code */
        Currency?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<CurrencyResponseDto[], void>({
        path: `/api/v3/currencies`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returned responses might be served from cache. Cached responses are delivered with the response header Cache-Control containing the max-age value in seconds indicating the cache interval set for the responses of this endpoint.
     *
     * @tags DeparturePoints
     * @name DeparturePointsGetDeparturePoint
     * @summary Get Departure points
     * @request GET:/api/v3/departurepoints
     * @secure
     */
    departurePointsGetDeparturePoint: (
      query: {
        /**
         * The three digits market code
         * @minLength 1
         */
        Market: string | null;
        /**
         * The program code
         * @minLength 1
         */
        Program: string | null;
        /** If it's a group or an individual travel */
        IsGroup?: boolean;
        /** Boolean code indicates the departure point is for public websites */
        IsPublic?: boolean | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeparturePoint[], void>({
        path: `/api/v3/departurepoints`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returned responses might be served from cache. Cached responses are delivered with the response header Cache-Control containing the max-age value in seconds indicating the cache interval set for the responses of this endpoint.
     *
     * @tags DeparturePoints
     * @name DeparturePointsGetAllDeparturePoints
     * @summary Get All departure points
     * @request GET:/api/v3/departurepoints/all
     * @secure
     */
    departurePointsGetAllDeparturePoints: (
      query?: {
        /** The three digits market code */
        Market?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeparturePointResponseDto[], void>({
        path: `/api/v3/departurepoints/all`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returned responses might be served from cache. Cached responses are delivered with the response header Cache-Control containing the max-age value in seconds indicating the cache interval set for the responses of this endpoint.
     *
     * @tags Destinations
     * @name DestinationsGetDestinationByCode
     * @summary Get destination by code
     * @request GET:/api/v3/destinations/{code}
     * @deprecated
     * @secure
     */
    destinationsGetDestinationByCode: (
      code: string,
      params: RequestParams = {},
    ) =>
      this.request<Destination, void>({
        path: `/api/v3/destinations/${code}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returned responses might be served from cache. Cached responses are delivered with the response header Cache-Control containing the max-age value in seconds indicating the cache interval set for the responses of this endpoint.
     *
     * @tags Destinations
     * @name DestinationsGetDestinationByCourseTypeV3
     * @summary Get destinations by course category for Poseidon groups
     * @request GET:/api/v3/destinations
     * @deprecated
     * @secure
     */
    destinationsGetDestinationByCourseTypeV3: (
      query: {
        /**
         * The three digit market code
         * @minLength 1
         */
        Market: string | null;
        /**
         * The program codes (separated by commas)
         * @minLength 1
         */
        Program: string | null;
        /** Filters Destinations based on age group. E.g. Senior, Junior */
        AgeGroup?: AgeGroup | null;
        /** The brochure as in year */
        Brochure?: string | null;
        /** City name (English) */
        City?: string | null;
        /**
         * ISO 3166 two letter country code
         * @pattern ^[A-Za-z]{2}$
         */
        CountryCode?: string | null;
        /** Filters Destinations By Course Category */
        CourseCategory?: string | null;
        /** The three digits currency code */
        Currency?: string | null;
        /** Filters by the destination code */
        DestinationCode?: string | null;
        /** Filters by the destination group */
        Group?: string | null;
        /** Boolean type to determine the destination contains public articles */
        HasPublicArticles?: boolean | null;
        /** ISO 639-1 two letter language code */
        Language?: string | null;
        /** Filters by individual/group offer types. Possible values: `Individual`, `Group` */
        OfferType?: OfferType;
        /** The season version */
        Season?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<DestinationByCourseCategory[], void>({
        path: `/api/v3/destinations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returned responses might be served from cache. Cached responses are delivered with the response header Cache-Control containing the max-age value in seconds indicating the cache interval set for the responses of this endpoint.
     *
     * @tags Destinations
     * @name DestinationsGet
     * @summary Get all active destinations' overview dtos
     * @request GET:/api/v3/destinations/active
     * @deprecated
     * @secure
     */
    destinationsGet: (params: RequestParams = {}) =>
      this.request<DestinationOverviewDto[], void>({
        path: `/api/v3/destinations/active`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FixedFlightFare
     * @name FixedFlightFareGetFixedFlightFare
     * @summary Gets Fixed Flight Fare
     * @request GET:/api/v3/fixedflightfare
     * @secure
     */
    fixedFlightFareGetFixedFlightFare: (
      query?: {
        /** The three digits currency code */
        Currency?: string | null;
        /** The departure point code */
        DeparturePoint?: string | null;
        /** The destination gateway code */
        DestinationGateway?: string | null;
        /** The hemisphere code */
        Hemisphere?: string | null;
        /** The three digits market code */
        Market?: string | null;
        /** The program code */
        Program?: string | null;
        /** The course start date */
        StartDate?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<FixedFlightFare, void>({
        path: `/api/v3/fixedflightfare`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericSupplements
     * @name GenericSupplementsGetAllGenericSeasonSupplements
     * @summary Get generic supplements with possibility to filter by parameters market, brochure, code, hemisphere.
     * @request GET:/api/v3/genericsupplements
     * @secure
     */
    genericSupplementsGetAllGenericSeasonSupplements: (
      query?: {
        /** The brochure represented as a year. If not provided, returns data for `ALL` markets. */
        Brochure?: string | null;
        /** The generic supplement code. */
        Code?: string | null;
        /** The two digits hemisphere code. */
        Hemisphere?: string | null;
        /** The three digits market code. If not provided, returns data for `ALL` markets. */
        Market?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<GenericSupplementResponseDto[], void>({
        path: `/api/v3/genericsupplements`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups
     * @name GroupsGetCoursesByGroupV3
     * @summary Get specific courses by group
     * @request GET:/api/v3/groups/courses
     * @secure
     */
    groupsGetCoursesByGroupV3: (
      query: {
        /**
         * Id of requested group
         * @minLength 1
         */
        GroupId: string | null;
        /** The brochure as in year */
        Brochure?: string | null;
        /** Code of requested group */
        GroupCode?: string | null;
        /** If set, cancelled groups will be included in search */
        IncludeCancelled?: boolean;
        /** If set, departed groups will be included in search */
        IncludeDepartedGroups?: boolean;
        IncludeInactiveBrochures?: boolean;
        /** Boolean code indicates the course is for public websites */
        IsPublic?: boolean;
        /** The season version */
        Season?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<CourseDto[], void>({
        path: `/api/v3/groups/courses`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ## Request body ``` { "importType":"ILSYCourses" } ```
     *
     * @tags ImportBatches
     * @name ImportBatchesGenerateUploadUrl
     * @summary Generate a signed URL to upload a file to S3
     * @request POST:/api/imports/batches
     * @secure
     */
    importBatchesGenerateUploadUrl: (params: RequestParams = {}) =>
      this.request<CreateImportBatchResponseDto, any>({
        path: `/api/imports/batches`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ImportBatches
     * @name ImportBatchesGetBatches
     * @summary Get the list of batches paginated. The order of the items is based on UpdatedAt descending
     * @request GET:/api/imports/batches
     * @secure
     */
    importBatchesGetBatches: (
      query?: {
        /**
         * @format int32
         * @default 10
         */
        limit?: number;
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedResponseOfImportBatchLightResponseDto, void>({
        path: `/api/imports/batches`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ImportBatches
     * @name ImportBatchesGetBatch
     * @summary Retrieve a single batch by its ID with full details
     * @request GET:/api/imports/batches/{id}
     * @secure
     */
    importBatchesGetBatch: (id: string, params: RequestParams = {}) =>
      this.request<ImportBatchResponseDto, void>({
        path: `/api/imports/batches/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * @description ## Request body ``` { "batchId":"d1b3b3b3-3b3b-3b3b-3b3b-3b3b3b3b3b3b" } ```
 *
 * @tags ImportBatches
 * @name ImportBatchesApplyBatch
 * @summary Apply a batch. This means that the prices that were staged in this batch will be applied
and the prices will be visibile though the product catalog API
 * @request POST:/api/imports/applied-batches
 * @secure
 */
    importBatchesApplyBatch: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/imports/applied-batches`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Programs
     * @name ProgramsGetProgram
     * @summary Get a list of enabled programs by market
     * @request GET:/api/v3/programs
     * @secure
     */
    programsGetProgram: (
      query: {
        /**
         * The three digit market code
         * @minLength 1
         * @maxLength 3
         */
        Market: string | null;
        /** The program code */
        Code?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProgramEntity[], void>({
        path: `/api/v3/programs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * @description The endpoint requires at least one of the following parameters: market, program, language, destination, currency, sku. Should brochure and season not be provided, the result will be filtered by active/latest brochure automatically. Returned responses might be served from cache. Cached responses are delivered with the response header Cache-Control containing the max-age value in seconds indicating the cache interval set for the responses of this endpoint.
 *
 * @tags SalesItems
 * @name SalesItemsGetSalesItemsV3
 * @summary Get sales items. Similar to /api/v3/salesitems/overview,
except that it converts the Program from ILSY to ILC, if provided.
 * @request GET:/api/v3/salesitems
 * @secure
 */
    salesItemsGetSalesItemsV3: (
      query: {
        /** The three digit market code */
        Market: string | null;
        /** The program code */
        Program: string | null;
        /** The age group code */
        AgeGroup?: string | null;
        /** The brochure code as in year */
        Brochure?: string | null;
        /** The three digits currency code */
        Currency?: string | null;
        /** The departure point code */
        DeparturePoint?: string | null;
        /** The destination code */
        Destination?: string | null;
        /**
         * The course end date
         * @format date-time
         */
        EndDate?: string;
        /** Include (soft) deleted articles and prices from PII */
        IncludeDeleted?: boolean | null;
        /** Boolean type to filter articles disabled in PII */
        IncludeInactive?: boolean;
        /** Boolean type to filter system articles */
        IncludeSystemArticle?: boolean;
        /** Boolean type to filter the articles for public websites */
        IsPublic?: boolean | null;
        /** The language code */
        Language?: string | null;
        /** The season version */
        Season?: string | null;
        /** The article SKU */
        Sku?: string | null;
        /**
         * The course start date
         * @format date-time
         */
        StartDate?: string;
        /**
         * The article subtype
         * @format int32
         */
        SubType?: number;
        /**
         * The article type
         * @format int32
         */
        Type?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<SalesItemResponseDto[], void>({
        path: `/api/v3/salesitems`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Should brochure and season not be provided, the result will be filtered by active/latest brochure automatically. Returned responses might be served from cache. Cached responses are delivered with the response header Cache-Control containing the max-age value in seconds indicating the cache interval set for the responses of this endpoint.
     *
     * @tags SalesItems
     * @name SalesItemsGetSkuV3
     * @summary Get sales items based on sku
     * @request GET:/api/v3/salesitems/{sku}
     * @secure
     */
    salesItemsGetSkuV3: (
      sku: string,
      query: {
        /**
         * The three digit market code
         * @minLength 1
         */
        Market: string | null;
        /**
         * The program code
         * @minLength 1
         */
        Program: string | null;
        /** The age group code */
        AgeGroup?: string | null;
        /** The brochure code as in year */
        Brochure?: string | null;
        /** The currency of the price */
        Currency?: string | null;
        /** The departure point code */
        DeparturePoint?: string | null;
        /**
         * The course end date
         * @format date-time
         */
        EndDate?: string;
        /** Include (soft) deleted articles and prices from PII */
        IncludeDeleted?: boolean | null;
        /** Boolean type to filter articles disabled in PII */
        IncludeInactive?: boolean;
        /** Boolean type to filter system articles */
        IncludeSystemArticle?: boolean;
        /** Boolean type to filter the articles for public websites */
        IsPublic?: boolean | null;
        /** The language code */
        Language?: string | null;
        /** The season version */
        Season?: string | null;
        /**
         * The course start date
         * @format date-time
         */
        StartDate?: string;
        /**
         * The article subtype
         * @format int32
         */
        SubType?: number;
        /**
         * The article type
         * @format int32
         */
        Type?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<SalesItemResponseDto, void>({
        path: `/api/v3/salesitems/${sku}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Should brochure and season not be provided, the result will be filtered by active/latest brochure automatically. Returned responses might be served from cache. Cached responses are delivered with the response header Cache-Control containing the max-age value in seconds indicating the cache interval set for the responses of this endpoint.
     *
     * @tags SalesItems
     * @name SalesItemsGetAccommodationItems
     * @summary Get accommodation sales items
     * @request GET:/api/v3/salesitems/accommodation
     * @secure
     */
    salesItemsGetAccommodationItems: (
      query: {
        /**
         * The three digits currency code
         * @minLength 3
         * @maxLength 3
         */
        Currency: string | null;
        /**
         * The language code
         * @minLength 2
         * @maxLength 2
         */
        Language: string | null;
        /**
         * The three digit market code
         * @minLength 1
         * @maxLength 3
         */
        Market: string | null;
        /**
         * The program code
         * @minLength 1
         */
        Program: string | null;
        /** The age group code */
        AgeGroup?: string | null;
        /** The brochure code as in year */
        Brochure?: string | null;
        /** The departure point code */
        DeparturePoint?: string | null;
        /** The destination code */
        Destination?: string | null;
        /**
         * The course end date
         * @format date-time
         */
        EndDate?: string;
        /** Include (soft) deleted articles and prices from PII */
        IncludeDeleted?: boolean | null;
        /** Boolean type to filter articles disabled in PII */
        IncludeInactive?: boolean;
        /** Boolean type to filter system articles */
        IncludeSystemArticle?: boolean;
        /** Boolean type to filter the articles for public websites */
        IsPublic?: boolean | null;
        /** The season version */
        Season?: string | null;
        /** The article SKU */
        Sku?: string | null;
        /**
         * The course start date
         * @format date-time
         */
        StartDate?: string;
        /**
         * The article subtype
         * @format int32
         */
        SubType?: number;
        /**
         * The article type
         * @format int32
         */
        Type?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AccommodationSaleItem[], void>({
        path: `/api/v3/salesitems/accommodation`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * @description The endpoint requires at least one of the following parameters: market, program, language, destination, currency, sku. Should brochure and season not be provided, the result will be filtered by active/latest brochure automatically. Returned responses might be served from cache. Cached responses are delivered with the response header Cache-Control containing the max-age value in seconds indicating the cache interval set for the responses of this endpoint.
 *
 * @tags SalesItems
 * @name SalesItemsGetSalesItemsOverviewV3
 * @summary Get sales items. New endpoint replacing /api/v1.2/salesitems. Similar to /api/v3/salesitems,
without the conversion of the Program from ILSY to ILC.
 * @request GET:/api/v3/salesitems/overview
 * @secure
 */
    salesItemsGetSalesItemsOverviewV3: (
      query: {
        Market: string | null;
        Program: string | null;
        AgeGroup?: string | null;
        Brochure?: string | null;
        Currency?: string | null;
        DeparturePoint?: string | null;
        Destination?: string | null;
        /** @format date-time */
        EndDate?: string | null;
        IncludeDeleted?: boolean | null;
        IncludeInactive?: boolean;
        IncludeSystemArticle?: boolean;
        IsPublic?: boolean | null;
        Language?: string | null;
        Season?: string | null;
        Sku?: string | null;
        /** @format date-time */
        StartDate?: string | null;
        /** @format int32 */
        SubType?: number;
        /** @format int32 */
        Type?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<SalesItemResponseDto[], void>({
        path: `/api/v3/salesitems/overview`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Should brochure and season not be provided, the result will be filtered by active/latest brochure automatically. Returned responses might be served from cache. Cached responses are delivered with the response header Cache-Control containing the max-age value in seconds indicating the cache interval set for the responses of this endpoint.
     *
     * @tags SalesItems
     * @name SalesItemsGetNonAccommodationItems
     * @summary Get non accommodation sales items
     * @request GET:/api/v3/salesitems/non-accommodation
     * @secure
     */
    salesItemsGetNonAccommodationItems: (
      query: {
        /**
         * @minLength 1
         * @maxLength 3
         */
        Market: string | null;
        /** @minLength 1 */
        Program: string | null;
        AgeGroup?: string | null;
        Brochure?: string | null;
        Currency?: string | null;
        DeparturePoint?: string | null;
        Destination?: string | null;
        /** @format date-time */
        EndDate?: string | null;
        IsActive?: boolean;
        IsPublic?: boolean | null;
        Language?: string | null;
        Season?: string | null;
        Sku?: string | null;
        /** @format date-time */
        StartDate?: string | null;
        /** @format int32 */
        SubType?: number;
        /** @format int32 */
        Type?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<SalesItemResponseDto[], void>({
        path: `/api/v3/salesitems/non-accommodation`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags SalesItemsDue
 * @name SalesItemsDueGetSalesItemsDue
 * @summary Gets due values for the sales items for the current active year. Results might contain an empty array if there are no due
values defined for the current year.
 * @request GET:/api/salesitems/due
 * @secure
 */
    salesItemsDueGetSalesItemsDue: (
      query: {
        /**
         * The Brochure year. Eg. 2025
         * @minLength 1
         */
        Brochure: string | null;
        /**
         * Market code, e.g. DEB, DKC, DZA, ECQ, ESB, ESK, FIH, FRP, etc.
         * @minLength 1
         * @maxLength 3
         */
        Market: string | null;
        /**
         * The code of the program, e.g. ILS, ILSP, AY, PRW, MLY, MLYP, etc.
         * @minLength 1
         */
        Program: string | null;
        /**
         * The Brochure season. E.g. V3
         * @minLength 1
         */
        Season: string | null;
        /** The code of the sales item, e.g. AP2SFD, DCPSFD, DCP2SFD, RESSX-URSP, etc. If not provided, filter won't be applied. */
        Code?: string | null;
        /** If the sales item with the due value is enabled. If not provided, filter won't be applied. */
        IsEnabled?: boolean | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<SalesItemDueResultData[], void>({
        path: `/api/salesitems/due`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  odata = {
    /**
     * No description
     *
     * @tags OData
     * @name ProductCatalogODataGetPrices
     * @request GET:/odata/sales-item-prices
     * @secure
     */
    productCatalogODataGetPrices: (params: RequestParams = {}) =>
      this.request<PriceODataDto[], any>({
        path: `/odata/sales-item-prices`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OData
     * @name ProductCatalogODataGetPrice
     * @request GET:/odata/sales-item-prices({key})
     * @secure
     */
    productCatalogODataGetPrice: (key: number, params: RequestParams = {}) =>
      this.request<SingleResultOfPriceODataDto, any>({
        path: `/odata/sales-item-prices(${key})`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OData
     * @name ProductCatalogODataGetPriceImportEntries
     * @request GET:/odata/price-import-entries
     * @secure
     */
    productCatalogODataGetPriceImportEntries: (params: RequestParams = {}) =>
      this.request<PriceImportODataDto[], any>({
        path: `/odata/price-import-entries`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OData
     * @name ProductCatalogODataGetPriceImportEntry
     * @request GET:/odata/price-import-entries({key})
     * @secure
     */
    productCatalogODataGetPriceImportEntry: (
      key: number,
      params: RequestParams = {},
    ) =>
      this.request<SingleResultOfPriceImportODataDto, any>({
        path: `/odata/price-import-entries(${key})`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OData
     * @name ProductCatalogODataGetFixedFlightFareImportEntries
     * @request GET:/odata/fff-import-entries
     * @secure
     */
    productCatalogODataGetFixedFlightFareImportEntries: (
      params: RequestParams = {},
    ) =>
      this.request<FixedFlightFareImportODataDto[], any>({
        path: `/odata/fff-import-entries`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OData
     * @name ProductCatalogODataGetFixedFlightFareImportEntry
     * @request GET:/odata/fff-import-entries({key})
     * @secure
     */
    productCatalogODataGetFixedFlightFareImportEntry: (
      key: number,
      params: RequestParams = {},
    ) =>
      this.request<SingleResultOfFixedFlightFareImportODataDto, any>({
        path: `/odata/fff-import-entries(${key})`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OData
     * @name ProductCatalogODataGetTranslations
     * @request GET:/odata/sales-item-translations
     * @secure
     */
    productCatalogODataGetTranslations: (params: RequestParams = {}) =>
      this.request<TranslationODataDto[], any>({
        path: `/odata/sales-item-translations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OData
     * @name ProductCatalogODataInsertTranslation
     * @summary Inserts a new sales item translation record.
     * @request POST:/odata/sales-item-translations
     * @secure
     */
    productCatalogODataInsertTranslation: (params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/odata/sales-item-translations`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OData
     * @name ProductCatalogODataGetTranslation
     * @request GET:/odata/sales-item-translations({key})
     * @secure
     */
    productCatalogODataGetTranslation: (
      key: number,
      params: RequestParams = {},
    ) =>
      this.request<SingleResultOfTranslationODataDto, any>({
        path: `/odata/sales-item-translations(${key})`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OData
     * @name ProductCatalogODataUpdateTranslation
     * @summary Updates translation value on the sales item translation record with provided id.
     * @request POST:/odata/sales-item-translations({id})
     * @secure
     */
    productCatalogODataUpdateTranslation: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<File, any>({
        path: `/odata/sales-item-translations(${id})`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OData
     * @name ProductCatalogODataGetSalesItemInclusionTypes
     * @request GET:/odata/sales-item-inclusion-types
     * @secure
     */
    productCatalogODataGetSalesItemInclusionTypes: (
      params: RequestParams = {},
    ) =>
      this.request<SalesItemInclusionTypeODataDto[], any>({
        path: `/odata/sales-item-inclusion-types`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OData
     * @name ProductCatalogODataInsertInclusionType
     * @summary Inserts a new inclusion type record.
     * @request POST:/odata/sales-item-inclusion-types
     * @secure
     */
    productCatalogODataInsertInclusionType: (params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/odata/sales-item-inclusion-types`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OData
     * @name ProductCatalogODataGetSalesItemInclusionType
     * @request GET:/odata/sales-item-inclusion-types({key})
     * @secure
     */
    productCatalogODataGetSalesItemInclusionType: (
      key: number,
      params: RequestParams = {},
    ) =>
      this.request<SingleResultOfSalesItemInclusionTypeODataDto, any>({
        path: `/odata/sales-item-inclusion-types(${key})`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OData
     * @name ProductCatalogODataUpdateSalesItemInclusionType
     * @summary Updates inclusion type value on the quote rule record with provided id.
     * @request POST:/odata/sales-item-inclusion-types({id})
     * @secure
     */
    productCatalogODataUpdateSalesItemInclusionType: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<File, any>({
        path: `/odata/sales-item-inclusion-types(${id})`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OData
     * @name ProductCatalogODataGetFixedFlightFares
     * @request GET:/odata/fixed-flight-fares
     * @secure
     */
    productCatalogODataGetFixedFlightFares: (params: RequestParams = {}) =>
      this.request<FixedFlightFareODataDto[], any>({
        path: `/odata/fixed-flight-fares`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OData
     * @name ProductCatalogODataGetFixedFlightFare
     * @request GET:/odata/fixed-flight-fares({key})
     * @secure
     */
    productCatalogODataGetFixedFlightFare: (
      key: number,
      params: RequestParams = {},
    ) =>
      this.request<SingleResultOfFixedFlightFareODataDto, any>({
        path: `/odata/fixed-flight-fares(${key})`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OData
     * @name ProductCatalogODataGetBrochures
     * @request GET:/odata/brochures
     * @secure
     */
    productCatalogODataGetBrochures: (params: RequestParams = {}) =>
      this.request<BrochureODataDto[], any>({
        path: `/odata/brochures`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OData
     * @name ProductCatalogODataGetBrochure
     * @request GET:/odata/brochures({key})
     * @secure
     */
    productCatalogODataGetBrochure: (key: number, params: RequestParams = {}) =>
      this.request<SingleResultOfBrochureODataDto, any>({
        path: `/odata/brochures(${key})`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OData
     * @name ProductCatalogODataUpdateBrochure
     * @summary Updates brochure season with provided id. Only updates of IsEnabled, IsDefault, Start/End dates are accepted.
     * @request POST:/odata/brochures({id})
     * @secure
     */
    productCatalogODataUpdateBrochure: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<File, any>({
        path: `/odata/brochures(${id})`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Metadata
     * @name MetadataGetMetadata
     * @request GET:/odata/$metadata
     * @secure
     */
    metadataGetMetadata: (params: RequestParams = {}) =>
      this.request<IEdmModel, any>({
        path: `/odata/$metadata`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Metadata
     * @name MetadataGetServiceDocument
     * @request GET:/odata
     * @secure
     */
    metadataGetServiceDocument: (params: RequestParams = {}) =>
      this.request<ODataServiceDocument, any>({
        path: `/odata`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
